(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('delivery-option-agenzia', {
            parent: 'entity',
            url: '/delivery-option-agenzia?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.delivery_option_agenzia.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/delivery-option-agenzia/delivery-option-agenzias.html',
                    controller: 'Delivery_option_agenziaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delivery_option_agenzia');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('delivery-option-agenzia-detail', {
            parent: 'delivery-option-agenzia',
            url: '/delivery-option-agenzia/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.delivery_option_agenzia.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/delivery-option-agenzia/delivery-option-agenzia-detail.html',
                    controller: 'Delivery_option_agenziaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delivery_option_agenzia');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Delivery_option_agenzia', function($stateParams, Delivery_option_agenzia) {
                    return Delivery_option_agenzia.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'delivery-option-agenzia',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('delivery-option-agenzia-detail.edit', {
            parent: 'delivery-option-agenzia-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option-agenzia/delivery-option-agenzia-dialog.html',
                    controller: 'Delivery_option_agenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Delivery_option_agenzia', function(Delivery_option_agenzia) {
                            return Delivery_option_agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delivery-option-agenzia.new', {
            parent: 'delivery-option-agenzia',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option-agenzia/delivery-option-agenzia-dialog.html',
                    controller: 'Delivery_option_agenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                costo_unitario: null,
                                importo_fix: null,
                                max_buoni: null,
                                descrizione: null,
                                descrizione_costi: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('delivery-option-agenzia', null, { reload: 'delivery-option-agenzia' });
                }, function() {
                    $state.go('delivery-option-agenzia');
                });
            }]
        })
        .state('delivery-option-agenzia.edit', {
            parent: 'delivery-option-agenzia',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option-agenzia/delivery-option-agenzia-dialog.html',
                    controller: 'Delivery_option_agenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Delivery_option_agenzia', function(Delivery_option_agenzia) {
                            return Delivery_option_agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delivery-option-agenzia', null, { reload: 'delivery-option-agenzia' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delivery-option-agenzia.delete', {
            parent: 'delivery-option-agenzia',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option-agenzia/delivery-option-agenzia-delete-dialog.html',
                    controller: 'Delivery_option_agenziaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Delivery_option_agenzia', function(Delivery_option_agenzia) {
                            return Delivery_option_agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delivery-option-agenzia', null, { reload: 'delivery-option-agenzia' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
